// Selo preview
(function () {
  'use strict';

  const $form = $('.form-selos');
  if ($form[0]) {
    const $inptTitulo = $('#selo_titulo');
    const $tituloPreview = $('.selo-titulo-preview');
    const $inptCorTitulo = $('#cor_texto');
    const $inptCorFundo = $('#cor_fundo');

    // Título update
    $inptTitulo.on('keyup', tituloUpdate);
    function tituloUpdate(e) {
      const texto = $inptTitulo.val();
      $tituloPreview.text(texto);
    }

    // Cor título update
    $inptCorTitulo.on('change', corTituloUpdate);
    function corTituloUpdate(e) {
      const corTitulo = $(this).val();
      $tituloPreview.css('color', corTitulo);
    }

    // Cor fundo update
    $inptCorFundo.on('change', corFundoUpdate);
    function corFundoUpdate(e) {
      const corFundo = $(this).val();
      $tituloPreview.css('background', corFundo);
    }
  }
})();
